import React from "react";
import styled, { keyframes } from "styled-components";
import { fadeIn, slideInUp } from "react-animations";
import { drukText, Inter, letterSpacingDruk, scaleInFigure } from "../../Util/StyleProps";
import { numberWithSpaces } from "../../Helpers/CommonHelper";
import LinePath from "./LinePathSvg";
import { secondaryColor } from "../../Util/Colors";

const fadeInAnimation = keyframes`${fadeIn}`;

const G = styled.g``;

const BubbleContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const BarCircleValue = styled.foreignObject`
  // min-width: ${props => (props.width ? props.width : "100px")};
  width: ${props => (props.width ? props.width : "100%")};
  height: ${props => (props.height ? props.height : "100px")};
  font-family: ${Inter};
  line-height: 33px;
  animation: 2s ${props => (props.triggerAnimation ? scaleInFigure : "")} 0.5s
    cubic-bezier(0.175, 0.885, 0.275, 1.035);
  -webkit-animation: ${props => (props.triggerAnimation ? scaleInFigure : "")}
    0.5s cubic-bezier(0.175, 0.885, 0.275, 1.035);
  animation-delay: ${props => props.delay}s;
  animation-fill-mode: both;
  opacity: 0;
`;

const Bubble = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: ${props =>
    props.width ? `${parseInt(props.width, 10) * 0.7}px` : "100px"};

  background-color: #fff
  border-radius: 99px;
  padding: ${props => (props.padding ? props.padding : "9px 10px 6px")};
  text-align: center;
  width: 100%
`;

const ValueText = styled.span`
  font-size: ${props => (props.setFontSize ? props.setFontSize : "18px")}
  font-weight: 700;
  letter-spacing: ${letterSpacingDruk};
  line-height: 100%;
  padding: ${props => (props.padding ? props.padding : 0)};

`;

const LabelBottom = styled.span`
  font-family: ${Inter};
  font-size: ${props => (props.setFontSize ? props.setFontSize : "18px")}
  line-height: ${props => (props.lineHeight ? props.lineHeight  : "12px")}

  padding-top: ${props => (props.paddingTop ? props.paddingTop : 0)};
`;


const BubbleFlexSvg = props => {
  const {
    x,
    y,
    value,
    label,
    color,
    delay,
    triggerAnimation,
    hasBackground,
    padding,
    hasLine,
    lineType,
    isPercent,
    width,
    viewBoxWidth, // this affects the width the bubble inside  - the larger the viewBoxWidth the smaller the bubble
    viewBoxHeight,
    height
  } = props;

  const hasComma = toString(value).includes(",");

  return (
    <g>
      <BarCircleValue
        triggerAnimation={triggerAnimation}
        color={color}
        delay={delay}
        height={height}
        y={y}
        x={x}
        width={viewBoxWidth + "px"}
      >
        <BubbleContainer>
          <Bubble hasBackground={hasBackground} width={width} padding="7px 8px 5px">
            <ValueText
              setFontSize={"18px"}
            >
              {numberWithSpaces(value)}
              {isPercent ? "%" : ""}
            </ValueText>
            <LabelBottom
              paddingTop={"3px"}
              setFontSize={"5px"}
              lineHeight={"100%"}
            >
              {label}
            </LabelBottom>
          </Bubble>
        </BubbleContainer>
      </BarCircleValue>
      {lineType ? (
        <LinePath color={secondaryColor} lineType={lineType} x={x + 50} y={y + 53} />
      ) : null}
    </g>
  );
};
BubbleFlexSvg.defaultProps = {
  x: 0,
  y: 0,
  width: "100px",
  height: "100px",
  viewBoxWidth: 100,
  viewBoxHeight: 120,
  lineType: null,
  value: 0,
  label: "Label",
  isPercent: false,
  hasBackground: false,
  triggerAnimation: false,
  delay: 0,
  hasLine: false
};

export default BubbleFlexSvg;
